import { Typography } from 'components/typography';
import styles from './collections.module.scss';
import { CollectionFieldsFragment } from 'api/graphql-types';
import Card from 'components/card';

export interface ICollectionsModuleProps {
	module?: CollectionFieldsFragment;
}

const Collections = (props: ICollectionsModuleProps): React.JSX.Element => {
	const subHeadingTag = props.module?.overviewTitle ? 'h3' : 'h2';

	return (
		<div className={styles.collections}>
			{props.module?.overviewTitle && (
				<Typography tag={subHeadingTag} variant="h2">
					{props.module.overviewTitle}
				</Typography>
			)}
			<div className={styles.cards}>
				{props.module?.links.map((link) => (
					<Card
						key={link.title}
						title={link.title}
						slug={link.href.url || link.href.linkUrl}
						bodyText={<Typography variant="card">{link.description}</Typography>}
					/>
				))}
			</div>
		</div>
	);
};

export default Collections;
